import { IPromoTypeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetPromoTypeUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IPromoTypeRepositoryResponse> {
    return this.lookupRepository.getPromoTypes();
  }
}
